/**
 * Creates slug
 *
 * @param {string} name
 * @returns {string}
 */
export default (name = '') => {
  return name.toLowerCase().trim().replace(/\s+/g, '-');
};
